<template>
    <div v-wechat-title="title" class="padding5">
        <el-row type="flex" align="middle">
            <el-col class="align-right">
                <el-button type="primary" size="mini" @click="printAllItems">打印</el-button>
                <el-button type="primary" size="mini" @click="saveItems">保存</el-button>
            </el-col>
        </el-row>
        <list-view :showSequence="false" ref="supplies-list" :datalist="datalist" :tableHeight="this.screenHeight - 186" @extrabutton-click="ExtraButtonClick" :columns="columnList" :buttons="[]">
        </list-view>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `BeforeSurgeryUseDrug`,
    props: {},
    data() {
        return {
            title: `术前用药`,
            surgeryId: this.$route.query.surgery_id,
            token: this.$route.query.token,
            defaultBeforeUseDrugRecord: this.$root.DefaultBeforeUseDrugRecord,
            recordconfiglist: [],
            datalist: []
        }
    },
    created() {

    },
    computed: {
        ...mapGetters([`ward_auth`, `currentUser`, `screenHeight`, `active_ward`, `sys_enums`, `drug/drug_type`, `drug/drug_unit`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [{
                type: `string`,
                prop: `___index`,
                label: `unique`,
                isKey: true
            }, {
                type: `string`,
                prop: `id`,
                label: `编号`
                // isKey:true
            }, {
                type: `remoteselect`,
                prop: `dic_drug`,
                label: `名称`,
                isListable: true,
                options: `/api/AcisSystem/Drug/SearchBeforeSurgery`,
                readonly: function(that, { row, area }) {
                    if (area == `list`) {
                        return false
                    }
                    return true
                },
                change: (that, { row }) => {
                    let req = this.myaxios.get(`/api/AcisSystem/Drug/Get/${row.dic_drug.value}`)
                    req.then(data => {
                        // 不新增行
                        if (row.addrow != undefined) {
                            row.addrow = `0`
                            this.$set(row, `dic_drug_type_id`, data.drug_types && data.drug_types[0])
                            this.$set(row, `unit`, data.dic_unit_id)
                        } else {
                            row.addrow = `0`
                            this.$set(row, `dic_drug_type_id`, data.drug_types && data.drug_types[0])
                            this.$set(row, `unit`, data.dic_unit_id)
                            if (this.defaultBeforeUseDrugRecord && this.defaultBeforeUseDrugRecord != `0`) {
                                this.$set(row, `sys_record_config_id`, this.defaultBeforeUseDrugRecord)
                            }
                            this.$set(row, `use_date_time`, this.$moment(_.now()).format(`YYYY/MM/DD HH:mm`))
                            this.datalist.push({ ___index: _.now(), active: true })
                        }
                    }).catch(e => { })
                }
            }, {
                type: `float`,
                prop: `total_dose`,
                label: `用量`,
                width: `180`,
                isListable: true,
                readonly: function(that, { row, area }) {
                    if (area == `list`) {
                        return false
                    }
                    return true
                }
            }, {
                type: `select`,
                prop: `dic_drug_type_id`,
                label: `药品类型`,
                width: `120`,
                isListable: true,
                options: this[`drug/drug_type`],
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }],
                readonly: function(that, { row, area }) {
                    if (area == `list`) {
                        return false
                    }
                    return true
                }
            }, {
                type: `select`,
                prop: `unit`,
                label: `单位`,
                width: `120`,
                isListable: true,
                options: _.filter(this[`drug/drug_unit`], { isspeed: false }).map(d => {
                    return {
                        label: `${d.label}`,
                        value: d.value,
                        disabled: d.disabled
                    }
                }),
                readonly: function(that, { row, area }) {
                    if (area == `list`) {
                        return false
                    }
                    return true
                }
            }, {
                type: `select`,
                prop: `sys_record_config_id`,
                label: `记录单`,
                width: `180`,
                isListable: true,
                readonly: function(that, { row, area }) {
                    if (area == `list`) {
                        return false
                    }
                    return true
                },
                options: this.recordconfiglist
            }, {
                type: `datetime`,
                prop: `use_date_time`,
                label: `时间`,
                width: `180`,
                isListable: true,
                readonly: function(that, { row, area }) {
                    if (area == `list`) {
                        return false
                    }
                    return true
                }
            }, {
                type: `string`,
                prop: `remark`,
                label: `备注`,
                width: `180`,
                isListable: true,
                readonly: function(that, { row, area }) {
                    if (area == `list`) {
                        return false
                    }
                    return true
                }
            }, {
                type: `buttongroup`,
                prop: `oper`,
                label: `操作`,
                width: `60`,
                isListable: true,
                fixed: `right`,
                readonly: false,
                options: (that, { row }) => {
                    if (row.dic_drug) {
                        return [
                            {
                                class: `is-plain`,
                                label: `删除`,
                                icon: ``,
                                type: `danger`,
                                emit: `removeItem`,
                                permission: `default`
                            }
                        ]
                    }
                }
            }]
        },
        charge_item_options() {
            return new Promise(resolve => {
                let req = this.myaxios.get(`/api/AcisSystem/ChargeItem/SearchType`)
                req.then(data => {
                    data = _.map(data, d => {
                        return {}
                    })
                    resolve(data)
                })
            })
        }

    },
    mounted() {
        if (this.token) {
            sessionStorage.setItem(`token`, this.token)
            this.$store.dispatch(`ADD_CURRENTUSER`)
        }
        //  加载所有枚举
        this.$store.dispatch(`drug/ADD_DRUG_TYPE`)
        this.$store.dispatch(`drug/ADD_DRUG_UNIT`)
        this.$store.dispatch(`sysuser/ADD_WORKERS`)
        this.$store.dispatch(`enums/ADD_ALL_ENUM`)
        this.$store.dispatch(`ADD_WARD_AUTH`)
        // this.$store.dispatch("drug/ADD_DRUG_TYPE")
        this.$store.dispatch(`ADD_SECTION_AUTH`)
        this.loadItems().then(() => {
            this.loadRecordconfiglist()
        })
    },
    methods: {
        loadItems() {
            return new Promise((resolve, reject) => {
                if (!this.surgeryId) {
                    resolve()
                    return
                }
                var that = this
                let req = this.myaxios.get(`/api/AcisSystem/BeforeSurgeryUseDrug/GetBySurgeryInfoId?surgeryInfoId=${this.surgeryId}`)
                req.then(data => {
                    this.datalist = _.map(data, (d, index) => {
                        d.___index = _.now() + (index + 1) * 1000
                        d.dic_drug = {
                            label: (d.drug && d.drug.name) || ``,
                            value: (d.drug && d.drug.id) || 0,
                            code: (d.drug && d.drug.code) || 0,
                            abbr: (d.drug && d.drug.abbr) || 0
                        }
                        d.addrow = `0`
                        return d
                    })
                    that.datalist.push({ active: true })
                    resolve()
                }).catch(e => reject(e))
            })
        },
        loadRecordconfiglist() {
            return new Promise((resolve, reject) => {
                var that = this
                let req = this.myaxios.get(`/api/AcisSystem/RecordConfig/Get`)
                req.then(data => {
                    let r = _.map(_.filter(data, d => {
                        return !d.is_deleted
                    }), t => {
                        return {
                            value: t.id,
                            label: t.file_name
                        }
                    })
                    that.recordconfiglist = r
                    resolve()
                }).catch(e => reject(e))
            })
        },
        ExtraButtonClick(target) {
            if (this[target.emit]) {
                this[target.emit](target)
            } else {
                this.$emit(target.emit, target)
            }
        },
        removeItem({ row, index }) {
            if (row.id > 0) {
                let req = this.myaxios.delete(`/api/AcisSystem/BeforeSurgeryUseDrug/Delete/${row.id}`)
                req.then(data => {
                    this.datalist.splice(index, 1)
                })
            } else {
                this.datalist.splice(index, 1)
            }
        },
        saveItems() {
            return new Promise((resolve, reject) => {
                var nonePayTypeArr = []
                var savedata = _.filter(this.datalist, d => d.dic_drug && d.dic_drug != null)
                savedata.forEach(d => {
                    if (d.dic_drug == null || !d.total_dose || !d.dic_drug_type_id || !d.unit || !d.sys_record_config_id || !d.use_date_time) {
                        nonePayTypeArr.push(d)
                        this.$set(d, `class_name`, `fontred`)
                    } else {
                        this.$set(d, `class_name`, ``)
                    }
                })
                if (nonePayTypeArr.length > 0) {
                    this.$message.error(`药品、用量、药品类型、单位、记录单、时间不能为空！`)
                    return
                }
                let data1 = this.getAdd(savedata)
                let data2 = this.getEdit(savedata)
                if (data1.length > 0 || data2.length > 0) {
                    let req1 = this.myaxios.post(`/api/AcisSystem/BeforeSurgeryUseDrug/Post`, data1)
                    let req2 = this.myaxios.put(`/api/AcisSystem/BeforeSurgeryUseDrug/PutMany`, data2)
                    this.myaxios
                        .all(req1, req2)
                        .then(res => {
                            this.loadItems()
                            this.$message.success(`保存成功`)
                            resolve()
                        })
                        .catch(e => reject(e))
                } else {
                    this.$message.warning(`没有可保存项`)
                    resolve()
                }
            })
        },
        getAdd(savedata) {
            var that = this
            let data1 = _.map(
                _.filter(savedata, d => !d.id),
                d => {
                    return {
                        id: d.id,
                        total_dose: d.total_dose,
                        unit: d.unit,
                        sys_record_config_id: d.sys_record_config_id,
                        dic_drug_id: d.dic_drug.value,
                        dic_drug_type_id: d.dic_drug_type_id,
                        biz_surgery_info_id: that.surgeryId,
                        use_date_time: d.use_date_time,
                        remark: d.remark
                    }
                }
            )
            return data1
        },
        getEdit(savedata) {
            var that = this
            let data2 = _.map(
                _.filter(savedata, d => d.id > 0),
                d => {
                    return {
                        id: d.id,
                        total_dose: d.total_dose,
                        unit: d.unit,
                        sys_record_config_id: d.sys_record_config_id,
                        dic_drug_id: d.dic_drug.value,
                        dic_drug_type_id: d.dic_drug_type_id,
                        biz_surgery_info_id: that.surgeryId,
                        use_date_time: d.use_date_time,
                        remark: d.remark
                    }
                }
            )
            return data2
        },
        printAllItems() {
            let docId = this.$root.DOCUMENT[`SQYY001`]
            let req2 = this.myaxios.get(`/api/AcisSystem/Config/GetByKey?key=isShowSendPrintMessage`)
            req2.then(isShow => {
                this.$store.dispatch(`PRINT_PDF`, {
                    host: this.$root.DOCSERVICE_BASE,
                    params: Object.assign(
                        {
                            docid: docId,
                            id1: this.surgeryId
                        },
                        { isShowSendPrintMessage: isShow.value }
                    )
                })
            }).catch(e => {
                console.log(e)
            })
        },
        loadChargeItemList(q) {
            return new Promise(resolve => {
                let req = this.myaxios.get(`api/AcisSystem/Drug/Search?keyword=${q && q.keyword}`)
                req.then(data => {
                    data = _.map(data, d => {
                        return {
                            value: d.id,
                            label: d.name,
                            abbr: d.abbr,
                            code: d.code
                        }
                    })
                    resolve(data)
                })
            })
        }

    },
    watch: {
        $route: function(newUrl, oldUrl) {
            this.surgeryId = newUrl.query.surgery_id
            this.loadItems()
        }
    }
}
</script>
<style lang="less">
.config-column {
    width: 150px;
    overflow: hidden;
    margin: 20px 0;
}

.config-column .el-checkbox-group .el-checkbox {
    display: table-row;
}
</style>



// WEBPACK FOOTER //
// src/components/Surgery/BeforeSurgeryUseDrug/Index.vue